import script from "./SublocationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SublocationsPage.vue?vue&type=script&setup=true&lang=js"

import "./SublocationsPage.vue?vue&type=style&index=0&id=1ce14221&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce14221"]])

export default __exports__